module.exports = __webpack_public_path__ + "static/img/ch_bcg2.dd1d5bb1.png";